import { IStep } from "interfaces/sw/SWInterfaces";

export default function getStaleList(list: IStep[], addedGuids = new Set<string | undefined>()) : IStep[] {
    let result : IStep[] = [];

    for(const step of list){
        if(step.isStale && !addedGuids.has(step.rcGuid)){
            result.push(step);
            addedGuids.add(step.rcGuid);
        }
        else if(Array.isArray(step.children)){
            result.push(...getStaleList(step.children, addedGuids));
        }
    }
    return result;
}

export function getRandomContainerId() : number {
    return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
}